// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/range.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/weight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Images/time.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Images/altitude.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Images/speed.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Images/payload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../Images/lunch.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../Images/landing.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Awsix_aw-container__g\\+Q7E {
  width: 100%;
  height: 100vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("https://i.imgur.com/uQhUtvt.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}

/* Գլխավոր դիվը էկրանով ամբողջությամբ */
.Awsix_aw-section-one__m8Ih3 {
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 40px 60px;
}

/* Ձախ ներքևի տեքստ */
.Awsix_aw-container__g\\+Q7E h3 {
  font-size: 80px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  color: rgba(255, 255, 255, 0.5019607843);
  opacity: 0.5;
  margin-top: 550px;
}

/* Աջ կողմի նկարը */
.Awsix_aw-image__qpA1w {
  width: 1800px;
  height: 750px;
  background-image: url("https://i.imgur.com/oRUQzhm.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.Awsix_sections__pPVlW {
  width: 100%;
  max-width: 1500px;
  margin: auto;
  margin-top: -180px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.Awsix_sections-child__E0PCz {
  width: 324px;
  height: 225px;
  background-color: white;
  box-shadow: 1px 1px 1px;
  border-bottom: 1px solid;
  border-right: 1px solid;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 40px;
  transform: perspective(1px) translateZ(0);
  box-shadow: 2px 2px 2px transparent;
  transition-duration: 0.3s;
  transition-property: box-shadow, transform;
}

.Awsix_child-img__TVNju {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awsix_sections-child__E0PCz h2 {
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  color: #4C6D59;
  text-align: center;
}

.Awsix_sections-child__E0PCz p {
  color: #4C6D59;
  font-weight: 500;
  font-size: 25.5px;
  line-height: 100%;
}

.Awsix_weight-img__9TP1q {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awsix_time-img__OR-ob {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awsix_altitude-img__XICX5 {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awsix_speed-img__JzPdG {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awsix_payload-img__T\\+Uk5 {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awsix_lunch-img__Z2OBq {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awsix_landing-img__7vFXA {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awsix_p-Container__UvqF\\+ {
  width: 80%;
}

.Awsix_p-Container__UvqF\\+ p {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Awsix_paragraph-section__yn1YI {
  width: 80%;
  background-color: #4C6D59;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 150px;
}

.Awsix_paragraph-section__yn1YI {
  width: 80%;
  background-color: #4C6D59;
  color: white;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 150px;
}

.Awsix_paragraph-big__uBIJw {
  width: 100%;
  margin: auto;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 48px;
  position: relative;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
}

.Awsix_paragraph-big__uBIJw p {
  color: white;
  font-size: 32px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  width: 65%;
  line-height: 1.4;
}

.Awsix_product-section__\\+JN\\+5 {
  width: 80%;
  height: 113px;
  display: flex;
  margin: auto;
  background-color: #252626;
  margin-bottom: 100px;
  justify-content: space-around;
  align-items: center;
}

.Awsix_product-section__\\+JN\\+5 span {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Awsix_product-section__\\+JN\\+5 button {
  width: 300px;
  height: 66px;
  border-radius: 32px;
  border: solid white;
  background-color: #252626;
  color: white;
  font-size: 32px;
  font-weight: 700;
  cursor: pointer;
}

.Awsix_paragraph-small-container__5ypeN {
  display: flex;
  height: 60%;
  margin-top: 200px;
  flex-direction: column;
  justify-content: space-between;
  margin-left: -70px;
  z-index: 99;
}

.Awsix_paragraph-small__0jSHH {
  width: 149px;
  height: 94px;
  border: 2px solid white;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: white;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
}

@media (max-width: 1000px) {
  .Awsix_product-section__\\+JN\\+5 {
    margin-top: -340px;
  }
  .Awsix_product-section__\\+JN\\+5 span {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .Awsix_product-section__\\+JN\\+5 button {
    font-size: 16px;
    height: 32px;
    width: 100px;
  }
}
@media screen and (max-width: 1024px) {
  .Awsix_paragraph-big__uBIJw {
    flex-direction: column;
    padding: 30px;
  }
  .Awsix_paragraph-section__yn1YI {
    max-width: 500px;
    width: 80%;
  }
  .Awsix_paragraph-big__uBIJw {
    margin-left: -2px;
  }
  .Awsix_sections-child__E0PCz {
    width: 280px;
    height: 250px;
  }
  .Awsix_paragraph-big__uBIJw p {
    width: 100%;
    font-size: 24px;
    margin-bottom: 30px;
    text-align: center;
  }
  .Awsix_paragraph-section__yn1YI {
    height: 500px;
  }
  .Awsix_p-Container__UvqF\\+ p {
    color: white;
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    font-family: "Roboto", sans-serif;
  }
  .Awsix_p-Container__UvqF\\+ h2 {
    font-size: 20px;
  }
  .Awsix_p-Container__UvqF\\+ p {
    font-size: 14px;
  }
  .Awsix_aw-section-one__m8Ih3 h3 {
    margin-top: 360px;
  }
  .Awsix_aw-container__g\\+Q7E {
    height: 800px;
  }
  .Awsix_sections-child__E0PCz {
    margin: auto;
    margin-bottom: 25px;
  }
  .Awsix_product-section__\\+JN\\+5 {
    margin-top: -500px;
    height: 100px;
  }
  .Awsix_product-section__\\+JN\\+5 span {
    margin-top: 22px;
  }
  .Awsix_aw-image__qpA1w {
    width: 400px;
    height: 200px;
    background-size: cover;
    margin-left: -110px;
    margin-top: -40px;
  }
  .Awsix_paragraph-small__0jSHH {
    width: 130px;
    height: 70px;
    font-size: 14px;
    margin-left: 30px;
  }
}
@media screen and (max-width: 600px) {
  .Awsix_sections-child__E0PCz {
    width: 150px;
    height: 150px;
  }
  .Awsix_sections-child__E0PCz h2 {
    font-size: 17px;
    margin-top: 2.5px;
  }
  .Awsix_sections-child__E0PCz p {
    font-size: 14px;
  }
  .Awsix_paragraph-section__yn1YI {
    margin-top: 200px;
  }
  .Awsix_aw-section-one__m8Ih3 h3 {
    margin-top: 180px;
    font-size: 19px;
  }
  .Awsix_aw-container__g\\+Q7E {
    height: 60vh;
  }
  .Awsix_paragraph-big__uBIJw p {
    font-size: 16px;
  }
  .Awsix_paragraph-small__0jSHH {
    width: 110px;
    height: 60px;
    font-size: 12px;
    margin-left: 30px;
  }
  .Awsix_paragraph-small-container__5ypeN {
    flex-direction: column;
    gap: 16px;
    height: 300px;
  }
  .Awsix_sections-child__E0PCz {
    width: 145px;
    height: 140px;
  }
  .Awsix_child-img__TVNju {
    width: 50px;
    height: 50px;
  }
  .Awsix_weight-img__9TP1q {
    width: 50px;
    height: 50px;
  }
  .Awsix_time-img__OR-ob {
    width: 50px;
    height: 50px;
  }
  .Awsix_altitude-img__XICX5 {
    width: 50px;
    height: 50px;
  }
  .Awsix_speed-img__JzPdG {
    width: 50px;
    height: 50px;
  }
  .Awsix_payload-img__T\\+Uk5 {
    width: 50px;
    height: 50px;
  }
  .Awsix_lunch-img__Z2OBq {
    width: 50px;
    height: 50px;
  }
  .Awsix_landing-img__7vFXA {
    width: 50px;
    height: 50px;
  }
}
@media screen and (max-width: 530px) {
  .Awsix_paragraph-big__uBIJw p {
    font-size: 12px;
  }
  .Awsix_paragraph-small-container__5ypeN {
    margin-top: 160px;
  }
  .Awsix_paragraph-big__uBIJw {
    height: 500px;
  }
}
@media screen and (min-width: 1025px) {
  .Awsix_aw-section-one__m8Ih3 h3 {
    font-size: 68px;
    margin-top: 600px;
  }
}
.Awsix_sections-child__E0PCz:hover,
.Awsix_sections-child__E0PCz:focus,
.Awsix_sections-child__E0PCz:active {
  cursor: pointer;
  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);
  transform: scale(1.2);
}`, "",{"version":3,"sources":["webpack://./src/AW6/Awsix.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,kHAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AAEF;;AAEA,uCAAA;AACA;EACE,aAAA;EACA,8BAAA;EAEA,YAAA;EACA,WAAA;EACA,kBAAA;AAAF;;AAGA,qBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;AAAF;;AAGA,mBAAA;AACA;EACE,aAAA;EACA,aAAA;EACA,wDAAA;EACA,wBAAA;EACA,4BAAA;AAAF;;AAIA;EACE,WAAA;EACA,iBAAA;EAGA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,yBAAA;EACA,0CAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAJF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAOA;EACE,UAAA;AAJF;;AAaA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAVF;;AAaA;EACE,UAAA;EAEA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAXF;;AAcA;EACE,UAAA;EAEA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,0CAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAZF;;AAiBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;EACA,gBAAA;AAdF;;AAkBA;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;AAfF;;AAoBA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAjBF;;AAoBA;EAEE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;EAIA,kBAAA;EACA,WAAA;AArBF;;AA0BA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;EACA,6BAAA;AAvBF;;AA2BA;EAGE;IACE,kBAAA;EA1BF;EA6BA;IACE,eAAA;IACA,mBAAA;EA3BF;EA+BA;IACE,eAAA;IACA,YAAA;IACA,YAAA;EA7BF;AACF;AAiCA;EACE;IACE,sBAAA;IACA,aAAA;EA/BF;EAmCA;IACE,gBAAA;IACA,UAAA;EAjCF;EAsCA;IAEE,iBAAA;EArCF;EAwCA;IACE,YAAA;IACA,aAAA;EAtCF;EAyCA;IACE,WAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EAvCF;EA0CA;IACE,aAAA;EAxCF;EA0CA;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,iCAAA;EAxCF;EA0CA;IACE,eAAA;EAxCF;EA6CA;IACE,eAAA;EA3CF;EA+CA;IAEE,iBAAA;EA9CF;EAmDA;IACE,aAAA;EAjDF;EA2DA;IACE,YAAA;IACA,mBAAA;EAzDF;EA6DA;IACE,kBAAA;IACA,aAAA;EA3DF;EA8DA;IACE,gBAAA;EA5DF;EA+DA;IAEE,YAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,iBAAA;EA9DF;EAkEA;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAhEF;AACF;AAkEA;EAEE;IACE,YAAA;IACA,aAAA;EAjEF;EAoEA;IACE,eAAA;IACA,iBAAA;EAlEF;EAqEA;IACE,eAAA;EAnEF;EAsEA;IACE,iBAAA;EApEF;EA2EA;IAEE,iBAAA;IACA,eAAA;EA1EF;EA4EA;IACE,YAAA;EA1EF;EA6EA;IACE,eAAA;EA3EF;EA8EA;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EA5EF;EAiFA;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EA/EF;EAmFA;IACE,YAAA;IACA,aAAA;EAjFF;EAmFA;IACE,WAAA;IACA,YAAA;EAjFF;EAoFA;IACE,WAAA;IACA,YAAA;EAlFF;EAqFA;IACE,WAAA;IACA,YAAA;EAnFF;EAsFA;IACE,WAAA;IACA,YAAA;EApFF;EAuFA;IACE,WAAA;IACA,YAAA;EArFF;EAwFA;IACE,WAAA;IACA,YAAA;EAtFF;EAwFA;IACE,WAAA;IACA,YAAA;EAtFF;EAwFA;IACE,WAAA;IACA,YAAA;EAtFF;AACF;AA4FA;EACE;IACE,eAAA;EA1FF;EA6FA;IACE,iBAAA;EA3FF;EA8FA;IACE,aAAA;EA5FF;AACF;AAiGA;EACE;IAEE,eAAA;IACA,iBAAA;EAhGF;AACF;AAyGA;;;EAGE,eAAA;EACA,mDAAA;EACA,qBAAA;AAvGF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.aw-container {\n  width: 100%;\n  height: 100vh;\n  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(\"https://i.imgur.com/uQhUtvt.jpeg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: relative;\n\n}\n\n/* Գլխավոր դիվը էկրանով ամբողջությամբ */\n.aw-section-one {\n  display: flex;\n  justify-content: space-between;\n  //align-items: flex-end;\n  height: 100%;\n  width: 100%;\n  padding: 40px 60px;\n}\n\n/* Ձախ ներքևի տեքստ */\n.aw-container h3 {\n  font-size: 80px;\n  font-weight: 700;\n  font-family: 'Roboto', sans-serif;\n  color: #FFFFFF80;\n  opacity: 0.5;\n  margin-top: 550px;\n}\n\n/* Աջ կողմի նկարը */\n.aw-image {\n  width: 1800px;\n  height: 750px;\n  background-image: url(\"https://i.imgur.com/oRUQzhm.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  //background-position: center;\n}\n\n.sections {\n  width: 100%;\n  max-width: 1500px;\n  //height: 70vh;\n  //background-color: red;\n  margin: auto;\n  margin-top: -180px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.sections-child {\n  width: 324px;\n  height: 225px;\n  background-color: white;\n  box-shadow: 1px 1px 1px;\n  //display: flex;\n  border-bottom: 1px solid;\n  border-right: 1px solid;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 40px;\n  transform: perspective(1px) translateZ(0);\n  box-shadow: 2px 2px 2px transparent;\n  transition-duration: 0.3s;\n  transition-property: box-shadow, transform;\n}\n\n.child-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/range.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.sections-child h2 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 100%;\n  color: #4C6D59;\n  text-align: center;\n}\n\n.sections-child p {\n  color: #4C6D59;\n  font-weight: 500;\n  font-size: 25.5px;\n  line-height: 100%;\n}\n\n.weight-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/weight.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.time-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/time.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n\n.altitude-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/altitude.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.speed-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/speed.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.payload-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/payload.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.lunch-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/lunch.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.landing-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/landing.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n.p-Container {\n  width: 80%;\n  //display: flex;\n\n  //justify-content: center;\n  //align-items: center;\n  //text-align: center;\n\n}\n\n.p-Container p{\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.paragraph-section {\n  width: 80%;\n  //height: 70vh;\n  background-color: #4C6D59;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  margin-top: 100px;\n  margin-bottom: 150px;\n}\n\n.paragraph-section {\n  width: 80%;\n  //height: 70vh;\n  background-color: #4C6D59;\n  color: white;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  margin-top: 100px;\n  margin-bottom: 150px;\n}\n\n.paragraph-big {\n  width: 100%;\n  margin: auto;\n  padding: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  background-color: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 48px;\n  position: relative;\n  margin-top: 100px;\n  margin-bottom: 100px;\n  text-align: center;\n\n\n}\n\n.paragraph-big p {\n  color: white;\n  font-size: 32px;\n  font-weight: 500;\n  font-family: 'Roboto', sans-serif;\n  width: 65%;\n  line-height: 1.4;\n\n}\n\n.product-section {\n  width: 80%;\n  height: 113px;\n  display: flex;\n  margin: auto;\n  background-color: #252626;\n  margin-bottom: 100px;\n  justify-content: space-around;\n  align-items: center;\n\n\n}\n\n.product-section span {\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.product-section button {\n  width: 300px;\n  height: 66px;\n  border-radius: 32px;\n  border: solid white;\n  background-color: #252626;\n  color: white;\n  font-size: 32px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.paragraph-small-container {\n  //width: 30%;\n  display: flex;\n  height: 60%;\n  margin-top: 200px;\n  flex-direction: column;\n  justify-content: space-between;\n  //align-items: flex-end;\n  //background-color: red;\n  //position: absolute;\n  margin-left: -70px;\n  z-index: 99;\n\n\n}\n\n.paragraph-small {\n  width: 149px;\n  height: 94px;\n  border: 2px solid white;\n  border-radius: 19px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  font-family: 'Roboto', sans-serif;\n  background-color: transparent;\n\n}\n\n@media (max-width: 1000px) {\n\n\n  .product-section{\n    margin-top: -340px;\n  }\n\n  .product-section span {\n    font-size: 16px;\n    margin-bottom: 20px;\n\n  }\n\n  .product-section button {\n    font-size: 16px;\n    height: 32px;\n    width:100px;\n\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .paragraph-big {\n    flex-direction: column;\n    padding: 30px;\n    //height: 50vh;\n\n  }\n  .paragraph-section {\n    max-width: 500px;\n    width: 80%;\n\n    //margin: auto;\n    //background-color: red;\n  }\n  .paragraph-big {\n    //background-color: red;\n    margin-left: -2px;\n  }\n\n  .sections-child {\n    width: 280px;\n    height: 250px;\n  }\n\n  .paragraph-big p {\n    width: 100%;\n    font-size: 24px;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n  .paragraph-section{\n    height: 500px;\n  }\n  .p-Container p{\n    color: white;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 100%;\n    font-family: 'Roboto', sans-serif;\n  }\n  .p-Container h2{\n    font-size: 20px;\n  }\n\n\n\n  .p-Container p{\n    font-size: 14px;\n  }\n\n\n  .aw-section-one h3 {\n    //background-color: red;\n    margin-top: 360px;\n    //font-size: 19px;\n\n  }\n\n  .aw-container {\n    height: 800px;\n  }\n\n  //.paragraph-small-container {\n  //  margin: 0 auto;\n  //  flex-direction: row;\n  //  justify-content: center;\n  //  gap: 20px;\n  //  height: auto;\n  //}\n  .sections-child {\n    margin: auto;\n    margin-bottom: 25px;\n  }\n\n\n  .product-section {\n    margin-top: -500px;\n    height: 100px;\n  }\n\n  .product-section span{\n    margin-top: 22px;\n  }\n\n  .aw-image {\n    //margin: auto;\n    width: 400px;\n    height: 200px;\n    background-size: cover;\n    margin-left: -110px;\n    margin-top: -40px;\n\n  }\n\n  .paragraph-small {\n    width: 130px;\n    height: 70px;\n    font-size: 14px;\n    margin-left: 30px;\n  }\n}\n@media screen and (max-width: 600px) {\n\n  .sections-child{\n    width: 150px;\n    height: 150px;\n  }\n\n  .sections-child h2{\n    font-size: 17px;\n    margin-top: 2.5px;\n  }\n\n  .sections-child p{\n    font-size: 14px;\n  }\n\n  .paragraph-section {\n    margin-top: 200px;\n\n  }\n\n\n\n\n  .aw-section-one h3 {\n    //background-color: red;\n    margin-top: 180px;\n    font-size: 19px;\n  }\n  .aw-container {\n    height: 60vh;\n  }\n\n  .paragraph-big p {\n    font-size: 16px;\n  }\n\n  .paragraph-small {\n    width: 110px;\n    height: 60px;\n    font-size: 12px;\n    margin-left: 30px;\n\n\n  }\n\n  .paragraph-small-container {\n    flex-direction: column;\n    gap: 16px;\n    height: 300px;\n  }\n\n\n  .sections-child{\n    width: 145px;\n    height: 140px;\n  }\n  .child-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .weight-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .time-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .altitude-img{\n    width: 50px;\n    height: 50px;\n\n  }\n  .speed-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .payload-img{\n    width: 50px;\n    height: 50px;\n  }\n  .lunch-img{\n    width: 50px;\n    height: 50px;\n  }\n  .landing-img{\n    width: 50px;\n    height: 50px;\n  }\n\n}\n\n\n\n@media screen and (max-width: 530px) {\n  .paragraph-big p {\n    font-size: 12px;\n  }\n\n  .paragraph-small-container {\n    margin-top: 160px;\n    //margin-left: 2px;\n  }\n  .paragraph-big {\n    height: 500px;\n  }\n\n}\n\n\n@media screen and (min-width: 1025px) {\n  .aw-section-one h3 {\n    //background-color: red;\n    font-size: 68px;\n    margin-top: 600px;\n  }\n  //.aw-container{\n  //  height: 50vh;\n  //}\n\n\n}\n\n\n.sections-child:hover,\n.sections-child:focus,\n.sections-child:active {\n  cursor: pointer;\n  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);\n  transform: scale(1.2);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aw-container": `Awsix_aw-container__g+Q7E`,
	"aw-section-one": `Awsix_aw-section-one__m8Ih3`,
	"aw-image": `Awsix_aw-image__qpA1w`,
	"sections": `Awsix_sections__pPVlW`,
	"sections-child": `Awsix_sections-child__E0PCz`,
	"child-img": `Awsix_child-img__TVNju`,
	"weight-img": `Awsix_weight-img__9TP1q`,
	"time-img": `Awsix_time-img__OR-ob`,
	"altitude-img": `Awsix_altitude-img__XICX5`,
	"speed-img": `Awsix_speed-img__JzPdG`,
	"payload-img": `Awsix_payload-img__T+Uk5`,
	"lunch-img": `Awsix_lunch-img__Z2OBq`,
	"landing-img": `Awsix_landing-img__7vFXA`,
	"p-Container": `Awsix_p-Container__UvqF+`,
	"paragraph-section": `Awsix_paragraph-section__yn1YI`,
	"paragraph-big": `Awsix_paragraph-big__uBIJw`,
	"product-section": `Awsix_product-section__+JN+5`,
	"paragraph-small-container": `Awsix_paragraph-small-container__5ypeN`,
	"paragraph-small": `Awsix_paragraph-small__0jSHH`
};
export default ___CSS_LOADER_EXPORT___;
